module.exports = __webpack_public_path__ + "img/logo_eng.1e280b0f.png";